module.exports = __webpack_public_path__ + "img/alert-icon.cbe21076.svg";